/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function LockLarge(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'LockLarge',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 16 * scale,
      viewBox: '0 0 14 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M11 7V5c0-2.2-1.8-4-4-4S3 2.8 3 5v2c-1.1 0-2 .9-2 2v6h12V9c0-1.1-.9-2-2-2m-3 5.722c-.295.172-.634.278-1 .278s-.705-.106-1-.278V9.278C6.295 9.106 6.634 9 7 9s.705.106 1 .278zM9 7H5V5c0-1.103.897-2 2-2s2 .897 2 2z"}))
}
